<template>
  <div class="Step-template">
    <div class="Step-header">
      <h1>{{ $t(`onBoarding.${stepName}.title`) }}</h1>
      <p>{{ $t(`onBoarding.${stepName}.subtitle`) }}</p>
    </div>
    <slot></slot>
    <v-alert v-if="error" class="mt-3" type="error">{{ error }}</v-alert>
    <v-row class="Step-footer">
      <v-col :class="{ 'align-end': bottomBtn }">
        <v-btn
          type="submit"
          class="Footer-btn flex-grow-1 flex-md-grow-0"
          :disabled="disabledBtn"
          :class="[{ 'Footer-btn--large': largeBtn }, `Footer-btn--${stepName}`]"
          @click="$emit('nextStep')"
          data-e2e="StepTemplateSubmitButton"
          depressed
          >{{ $t(`onBoarding.${stepName}.titleButton`) }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'StepTemplate',
  props: {
    bottomBtn: {
      type: Boolean,
      default: false
    },
    disabledBtn: {
      type: Boolean,
      default: false
    },
    error: String,
    stepName: {
      type: String
    },
    largeBtn: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.Step-template {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.Step-header {
  margin-bottom: 50px;
  > * {
    color: var(--v-secondary-base);
  }
  h1 {
    font-weight: 800;
  }
  p {
    font-weight: 300;
    font-size: 1.3rem;
  }
}

.Step-footer {
  > div {
    display: flex;
    justify-content: flex-end;
    padding-top: 50px;
    .Footer-btn {
      background-color: var(--v-primary-base) !important;
      color: #fff !important;
      transition: 0.35s ease-in-out;
      padding: 10px 25px;
      &--large {
        padding: 10px 50px;
      }
      &--stepSchedule {
        flex-grow: 0 !important;
      }
    }
  }
}

.App-nikon-it .Step-footer{
  > div {
    display: flex;
    justify-content: flex-end;
    padding-top: 50px;
    .Footer-btn {
      background-color: var(--v-primaryBtn-base) !important;
      border-color: var(--v-primaryBtn-base) !important;
      font-weight: bold !important;
      color: var(--v-secondary-base) !important;
      transition: 0.35s ease-in-out;
      padding: 10px 25px;
      &--large {
        padding: 10px 50px;
      }
      &--stepSchedule {
        flex-grow: 0 !important;
      }
    }
  }
}
</style>
